"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 32px;\n  border-radius: 32px;\n  border: 1px solid ", ";\n  padding: 0 25px 0 10px;\n  align-items: center;\n  justify-content: flex-start;\n  background: ", ";\n  cursor: pointer;\n\n  &.disabled {\n    background: ", ";\n    cursor: not-allowed;\n  }\n\n  .icon {\n    margin-right: 5px;\n  }\n\n  .name {\n    font-size: 14px;\n    font-family: ", ";\n    color: ", ";\n    text-align: left;\n    text-transform: uppercase;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"], ["\n  display: flex;\n  height: 32px;\n  border-radius: 32px;\n  border: 1px solid ", ";\n  padding: 0 25px 0 10px;\n  align-items: center;\n  justify-content: flex-start;\n  background: ", ";\n  cursor: pointer;\n\n  &.disabled {\n    background: ", ";\n    cursor: not-allowed;\n  }\n\n  .icon {\n    margin-right: 5px;\n  }\n\n  .name {\n    font-size: 14px;\n    font-family: ", ";\n    color: ", ";\n    text-align: left;\n    text-transform: uppercase;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map